import { Injectable } from '@angular/core';
import { environment } from '@environments';
import { TipoInterfaces } from '@shared/enums/TipoInterfaces';

@Injectable({
  providedIn: 'root'
})
export class InterfacesService {

  interfazSAPUrl = environment.apiManagement.interfazSAP;
  interfazMonitorUrl = environment.apiManagement.interfazMonitorAsientos;
  interfazStockUrl = environment.apiManagement.interfazStock;
  interfazDocumentosComercialeskUrl = environment.apiManagement.interfazDocumentosComerciales;

  obtenerInterfazDesdeLogicApp(tipo) {
    const url = tipo==TipoInterfaces.STOCK ? this.interfazStockUrl : tipo==TipoInterfaces.SAP ? this.interfazSAPUrl : this.interfazDocumentosComercialeskUrl;

    const headers = new Headers({
      'Ocp-Apim-Subscription-Key': '7173572bea1e4940b892c93293bb994e'
    });

    return fetch(url, {
      method: 'GET',
      headers: headers
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error: ' + response.statusText);
        }
        return response.json();
      })
      .then(data => {
        return data;
      })
      .catch(error => {
        console.error('Error:', error);
        throw error;
      });
  }

  obtenerInterfazClientes() {
    return [{
      nombre: "CENIT Clientes"
    }]
  }

  obtenerMonitorAsientosContables(fecha) {
    const url = this.interfazMonitorUrl + "&fecha=" + fecha;
    return fetch(url, {
      method: 'POST',
    })
      .then(async data => {
        const response = await data.json();
        return response.ITEM;
      })
      .catch(error => {
        console.error('Error:', error);
        throw error;
      });
  }
}
